import { JAVA_SVC } from "../config";
import store from "../store/redux";

export async function apiFetch(path, options = {}) {
  const { selectedCode } = store.getState().country;

  const token = localStorage.getItem("muradi_web-userSessionId");

  return fetch(`${JAVA_SVC}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "X-Country": selectedCode,

      ...(token && {
        Authorization: `Bearer ${token}`,
      }),

      ...options.headers,
    },
  });
}
// import { JAVA_SVC } from "../config";
// import store from "../store/redux";
// export async function apiFetch(path, options = {}) {
//   const { selectedCode } = store.getState().country;

//   return fetch(`${JAVA_SVC}${path}`, {
//     ...options,
//     headers: {
//       "Content-Type": "application/json",
//       "X-Country": selectedCode,
//       ...options.headers,
//     },
//   });
// }
